import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n/useTranslation';
import { useGoogleSignIn } from '../../../Utils/useGoogleSignIn';
import { routes } from '../../../Utils/routes';
import { Spinner } from '../../SharedArea/Spinner/Spinner';
import { ProductPanel } from '../../SharedArea/ProductPanel/ProductPanel';
import './Home.css';

/**
 * A split screen rather than a scrolling pitch: headline and the one action
 * that matters on one side, the product itself on the other. What the app
 * does is shown once someone is signed in, not argued for here.
 *
 * It is composed like the sign-in screen on purpose, and shares its actual
 * behaviour too: this button signs in directly rather than forwarding to
 * Login for a second, near-identical screen to do it. Login still exists for
 * a direct or bookmarked visit to /user while signed out, not as a required
 * second step from here.
 */
export function Home() {
  const { tr } = useTranslation();
  const { signIn, busy, failed } = useGoogleSignIn();

  return (
    <section className="home-hero">
      <div className="home-hero-grid">
        <div className="home-hero-left">
          <p className="home-hero-eyebrow">{tr('tagline')}</p>
          <h1 className="home-hero-title">{tr('heroTitle')}</h1>
          <p className="home-hero-sub">{tr('heroSub')}</p>

          <div className="entrance-card home-auth-card">
            <button type="button" className="entrance-google" onClick={() => void signIn()} disabled={busy}>
              {busy ? <Spinner inline /> : <GoogleMark />}
              <span>{tr('ctaButton')}</span>
            </button>
            {failed && <p className="entrance-error" role="alert">{tr('loginFailed')}</p>}
          </div>

          <Link className="entrance-secondary home-secondary-link" to={routes.pricing}>
            {tr('navPricing')}
          </Link>
        </div>

        <div className="home-hero-right">
          <ProductPanel />
        </div>
      </div>
    </section>
  );
}

function GoogleMark() {
  return (
    <svg viewBox="0 0 18 18" width="18" height="18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3-2.33z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
    </svg>
  );
}
